import React from 'react';
import {FormInput, RadioGroup} from 'react-form';
import _ from 'lodash';
import {RadioButton} from 'material-ui';

export default ( { field, options, ...rest } ) => {
  return (
    <FormInput field={field}>
      {( { setValue, getValue, setTouched } ) => {
        return (
          <RadioGroup field={field}>
            {_.map( options, ( option, index ) =>
              <RadioButton key={index}
                           id={`${field}_${index}`}
                           name={field}
                           labelPosition="left"
                           label={option.label}
                           value={option.id}
                           checked={_.isObject( getValue() ) ? getValue().id === option.id : _.toString( getValue() ) === _.toString( option.id )}
                           onCheck={( event, value ) => setValue( value )}
                           onBlur={() => setTouched()}
                           {...rest}
              />
            )}
          </RadioGroup>
        )
      }}
    </FormInput>
  )
}


// WEBPACK FOOTER //
// ./components/FormElements/RadioButton/index.js